import { Adapter as r } from "../../../adapter.js";
import { TicketServiceModel as t } from "./ticketService.model.js";
class c extends r {
  adapt(e) {
    return new t({
      now: e.now,
      readyAt: new Date(e.ready_at * 1e3),
      serviceType: e.service_type,
      tableId: e.table_id
    });
  }
  serialize(e) {
  }
}
export {
  c as TicketServiceAdapter
};
//# sourceMappingURL=ticketService.adapter.js.map
